var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadge = function SvgBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m14.6 8.6-.1-.1c-.2-.6-.2-1.3 0-1.8l.1-.2c.5-1.2-.1-2.6-1.3-3.2l-.2-.1c-.6-.2-1.1-.7-1.3-1.3l-.1-.2C11.2.5 9.8-.1 8.5.4l-.1.1c-.6.2-1.3.2-1.9 0L6.4.4C5.2-.1 3.8.5 3.2 1.7v.2c-.3.6-.7 1-1.3 1.3h-.2C.5 3.8-.1 5.2.4 6.4l.1.1c.2.6.2 1.3 0 1.8l-.1.3c-.5 1.2.1 2.6 1.3 3.1l.2.1c.6.2 1.1.7 1.3 1.3l.1.2c.5 1.2 1.9 1.8 3.1 1.3l.2-.1c.6-.2 1.3-.2 1.9 0l.1.1c1.2.5 2.6-.1 3.2-1.3l.1-.1c.2-.6.7-1.1 1.3-1.3h.1c1.2-.6 1.8-2 1.3-3.3zm-7.8 2L3.7 8l1-1.1 2 1.7 3.5-4.2 1.1 1-4.5 5.2z",
    clipRule: "evenodd"
  })));
};
export default SvgBadge;